import { Box, makeStyles, Theme } from '@material-ui/core'
import { FormattedDate, FormattedMessage } from 'react-intl'
import MDTooltip, { MDTooltipVariants } from './MDTooltip'
import { DataColumn } from '@src/components/DataTable/DataTable'
import DataTable from '@src/components/DataTable'

const useStyles = makeStyles((theme: Theme) => ({
  table: {
    '& .MuiTableHead-root': {
      background: theme.palette.common.white,
      borderTop: 'none',
    },

    '& .MuiTableCell-body': {
      fontSize: `${theme.typography.pxToRem(14)} !important`,
    },

    '& .MuiTableCell-root': {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },

    '& .MuiTableRow-root:last-child': {
      borderBottom: 'none',
    },
  },
  content: {
    marginTop: theme.spacing(-4),
    marginBottom: theme.spacing(-3),
  },
}))

const MDDeliveryCol = ({ item }) => {
  const classes = useStyles()

  // TODO: Remove hardcoded items
  const deliveryItems = [
    {
      lot: '1011821000',
      quantity: '10',
      shippedDate: '2015-01-02T18:21:43.977Z',
      saleOrderNo: '00025',
    },
    {
      lot: '1011821000',
      quantity: '10',
      shippedDate: '2015-01-02T18:21:43.977Z',
      saleOrderNo: '00035',
    },
    {
      lot: '1011821000',
      quantity: '10',
      shippedDate: '2015-01-02T18:21:43.977Z',
      saleOrderNo: '00002',
    },
  ]

  const dataColumns: DataColumn[] = [
    {
      headElement: (
        <FormattedMessage
          id="DELIVERY_LOT_BATCH"
          defaultMessage="Delivery Lot/Batch"
        />
      ),
      bodyElement: (lineItem) => lineItem.lot,
    },
    {
      headElement: (
        <FormattedMessage
          id="DELIVERY_QUANTITY"
          defaultMessage="Delivery Quantity"
        />
      ),
      bodyElement: (lineItem) => lineItem.quantity,
    },
    {
      headElement: (
        <FormattedMessage id="SHIPPED_DATE" defaultMessage="Shipped Date" />
      ),
      bodyElement: (lineItem) => (
        <FormattedDate
          value={lineItem.shippedDate}
          year="numeric"
          month="short"
          day="numeric"
        />
      ),
    },
    {
      headElement: (
        <FormattedMessage
          id="SALE_ORDER_ITEM_NO"
          defaultMessage="Sale Order Item No"
        />
      ),
      bodyElement: (lineItem) => lineItem.saleOrderNo,
    },
  ]

  return (
    <>
      <MDTooltip
        variant={MDTooltipVariants.delivery}
        title={
          <>
            <FormattedMessage id="ORDER_NUMBER" defaultMessage="Order Number" />
            : {item.orderNo}
          </>
        }
      >
        <>
          <Box>
            <Box className={classes.content}>
              <DataTable
                data={deliveryItems}
                columns={dataColumns}
                captionText={
                  <FormattedMessage
                    id="DOCUMENT_LIBRARY"
                    defaultMessage="Document Library"
                  />
                }
                noDataComponent={<p>No Data</p>}
                className={classes.table}
              />
            </Box>
          </Box>
        </>
      </MDTooltip>
    </>
  )
}

export default MDDeliveryCol
